import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import useRouteHandlers from './useRouteHandlers';

const propTypes = {
  handlerCallback: PropTypes.func,
  handlerName: PropTypes.string
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const RouteHandlerConnector = props => {
  const {handlerCallback, handlerName} = props;
  const routeHandlers = useRouteHandlers();

  useEffect(() => {
    const routeHandler = routeHandlers[handlerName];

    if (routeHandler && handlerCallback) {
      routeHandler(handlerCallback);
    } else if (routeHandler) {
      routeHandler();
    }
  }, [handlerName, handlerCallback, routeHandlers]);

  return <></>;
};
RouteHandlerConnector.propTypes = propTypes;
RouteHandlerConnector.displayName = 'RouteHandlerConnector';

export default RouteHandlerConnector;
